import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpHeaders
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TokenService } from '../login/services/token.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private router: Router, private tokenService: TokenService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // TODO To be replaced by authentication token when implemented
        const token = localStorage.getItem('authorization');
        const horaTope = Number(localStorage.getItem('horaTope'));
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', token) });
        }

        console.log('request', request);
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                     console.log('event--->>>', event);
                }
                if (horaTope) {
                    var horaActual = new Date();
                    let resta = Math.round((horaTope - horaActual.getTime()) / (60000));
                    if (resta <= environment.TIEMPO_RESTANTE) {
                        this.tokenService.refreshToken$().subscribe(data => {
                            localStorage.setItem('authorization', data);
                        }, err => console.log('Error en /usuario/me', err)
                        );
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status == 500 || error.status == 401) {
                    if (error.error.message.indexOf('JWT expired at') != -1) {
                        this.router.navigateByUrl('/');
                        localStorage.clear();
                    }
                }
                return throwError(error);
            }));
    }
}
